:host {
  --aha-promo-card--border-left-color: var(--aha-green-600);
  --aha-promo-card-width: 400px;
}

:host([with-overlay]) {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(241, 241, 241, 0.80) 0.87%, rgba(241, 241, 241, 0.76) 35.6%, rgba(241, 241, 241, 0.76) 70.28%, rgba(241, 241, 241, 0.80) 97.09%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
}


#aha-promo-card__promo-container {
  box-sizing: border-box;
  width: var(--aha-promo-card-width);
  background: white;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  border-radius: var(--Common--border-radius);
  border-left: solid 5px var(--aha-promo-card--border-left-color);
  padding: var(--spacer-6) var(--spacer-5) var(--spacer-3);
}

#aha-promo-card__actions-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

slot[name='image']::slotted(*) {
  height: 15px !important;
}

slot[name="title"]::slotted(*) {
  margin-top: var(--spacer-3);
  font-weight: 600;
  color: var(--theme-secondary-text);
}

slot[name="description"]::slotted(*) {
  margin-top: var(--spacer-2);
  color: var(--theme-secondary-text);
  width: 286px;
}
